import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GoogleAddressValidationRequest, GoogleAddressValidationResponse } from '../sagas/types';
import { initialGoogleAddressValidationApiState } from './constants';

const googleAddressValidationApiSlice = createSlice({
  name: 'googleAddressValidationApi',
  initialState: initialGoogleAddressValidationApiState,
  reducers: {
    updateIsAddressValid: (state, { payload }: PayloadAction<boolean>) => {
      state.isAddressValid = payload;
    },
    updateAddressValidationResult: (state, { payload }: PayloadAction<GoogleAddressValidationResponse>) => {
      state.addressValidationResult = payload;
    },
    resetAddressValidationState: () => initialGoogleAddressValidationApiState,
    triggerAddressValidation: (_, _action: PayloadAction<GoogleAddressValidationRequest>) => {},
  },
  selectors: {
    selectIsAddressValid: (state) => state.isAddressValid,
    selectAddressValidationResult: (state) => state.addressValidationResult,
  },
});

export const {
  updateIsAddressValid,
  triggerAddressValidation,
  updateAddressValidationResult,
  resetAddressValidationState,
} = googleAddressValidationApiSlice.actions;

export const { selectIsAddressValid, selectAddressValidationResult } = googleAddressValidationApiSlice.selectors;

export const googleAddressValidationApiReducer = googleAddressValidationApiSlice.reducer;
export const googleAddressValidationApiReducerPath = googleAddressValidationApiSlice.reducerPath;
